import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Único ponto de resolução de conflito entre classes Tailwind (Playbook §
 * Pilha de referência). Todo componente de `ui/` compõe className por aqui.
 *
 * O `tailwind-merge` não conhece a régua tipográfica própria do
 * `tailwind.config.js` (`text-label`, `text-cell`…): sem ensinar, ele trata
 * `text-label` como COR e descarta `text-on-primary` no mesmo botão — o
 * `Button` primário `size="sm"` ficava com texto escuro sobre azul.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['micro', 'label', 'cell', 'body', 'lede', 'card-title', 'section-title', 'page-title', 'kpi'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
